"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

var _common = require("../../utils/common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CertificatesController = function () {
  function CertificatesController(CertificatesService, FilterService, AuthService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CertificatesController);
    this.certificatesService = CertificatesService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  (0, _createClass3.default)(CertificatesController, [{
    key: "$onInit",
    value: function $onInit() {
      this.certificatesReviewStatusOptions = {
        dataSource: [{ value: 1, text: "Pending Verification" }, { value: 2, text: "Active" }, { value: 3, text: "Invalid" }, { value: 4, text: "Expired" }],
        dataTextField: "text",
        dataValueField: "value"
      };

      this.certificatesTypeOptions = {
        valuePrimitive: true,
        dataSource: [{ value: 0, text: "Unspecified" }, { value: 1, text: "Volunteer" }, { value: 2, text: "Paid" }],
        dataTextField: "text",
        dataValueField: "value"
      };
    }
  }, {
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      return {
        dataSource: this.certificatesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
        sortable: true,
        pageable: true,
        resizable: true,
        height: "90vh",
        noRecords: {
          template: "No Certificates."
        },
        columns: [{
          field: "fullName", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "8rem",
          template: function template(dataItem) {
            return "<a class=\"cell\" href=\"/users/" + dataItem.jugglerId + "\">" + dataItem.fullName + "</a>";
          }
        }, { field: "officialFullName", title: "Legal Name", filterable: false, sortable: false, width: "8rem" }, { field: "creationDate", title: "Upload Date", filterable: false, sortable: false, width: "4rem", template: "#= creationDate ? kendo.toString(new Date(creationDate), 'dd/MM/yyyy'): '-' #" }, { field: "dateOfBirth", title: "Date of Birth", filterable: false, sortable: false, width: "4rem", template: "#= dateOfBirth ? kendo.toString(new Date(dateOfBirth), 'dd/MM/yyyy'): '-' #" },
        // { field: "category", title: "Category", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getCategory(dataItem.category)}` },
        { field: "certificateTypeId", title: "Certificate Type", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getCertificateType(dataItem.certificateTypeId);
          } }, { field: "addressState", title: "State", filterable: false, sortable: false, width: "4rem" }, { field: "certificateNumber", title: "Certificate Number", filterable: false, sortable: false, width: "4rem" }, { field: "certificateStatus", title: "Certificate Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getCertificateStatus(dataItem.certificateStatus);
          } }, { field: "expiryDate", title: "Expiry Date", filterable: false, width: "4rem", sortable: false, template: "#= expiryDate ? kendo.toString(new Date(expiryDate), 'dd/MM/yyyy'): '-' #" },
        // { field: "verificationDate", title: "Verification Date", filterable: false, sortable: false, width: "4rem", template: `#= verificationDate ? kendo.toString(new Date(verificationDate), 'dd/MM/yyyy'): '-' #` },
        { title: "Update Status", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
        editable: {
          mode: "popup",
          window: { title: "Update Certificate Status" },
          template: kendo.template($("#popup-editor").html())
        }
      };
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.certificatesMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this2 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this2.applyFilters();
        }).catch(function (error) {
          _this2.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }, {
    key: "_getCertificateStatus",
    value: function _getCertificateStatus(status) {
      switch (status) {
        case _constants2.default.certificateStatus.PENDINGVERIFICATION:
          return "Pending Verification";
        case _constants2.default.certificateStatus.ACTIVE:
          return "Active";
        case _constants2.default.certificateStatus.INVALID:
          return "Invalid";
        case _constants2.default.certificateStatus.EXPIRED:
          return "Expired";
      }
    }
  }, {
    key: "_getCategory",
    value: function _getCategory(category) {
      switch (category) {
        case _constants2.default.certificateCategory.CHECK:
          return "Check";
        case _constants2.default.certificateCategory.FIRSTAID:
          return "First Aid";
        case _constants2.default.certificateCategory.QUALIFICATION:
          return "Qualification";
      }
    }
  }, {
    key: "_getCertificateType",
    value: function _getCertificateType(type) {
      switch (type) {
        case _constants2.default.certificateType.WWCC:
          return "WWCC";
      }
    }
  }]);
  return CertificatesController;
}();

exports.default = CertificatesController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/certificates/certificates.controller.js
 **/